import { RoleData } from '@/common/types/roles'
import { dateTimeTransformer } from '@/common/utils/dateTransformer'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import Button from '../../../common/components/Button'

export class ClientRolesTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (roles: RoleData[]) => {
      return roles.map((role) => {
        return {
          ...role,
          updatedAt: role.updated_at ? dateTimeTransformer(new Date(role.updated_at)) : '',
          actions: (
            <Link to={`/client-roles/${role.id}`}>
              <Button className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
